module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "select2-control hidden"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b2aaee0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tools/Select2.vue
// module id = 1690
// module chunks = 1